<template>
    <div class="check">
        <div class="check-list xw-scrollbar">

            <!--存在问题的检测项-->
            <el-collapse v-model="activeIndexs" v-if="isFinish">
                <el-collapse-item name="0">
                    <template slot="title">
                        <p class="item-title main">
                            共检测了<span class="error">{{progressData.itemNum}}</span>项，以下<span class="error">{{failList.length}}</span>项存在问题
                        </p>
                    </template>
                    <div class="clearfix">
                        <list-item
                                v-for="(item, index) in failList"
                                :item="item"
                                :key="index"
                                :isFinish="isFinish"
                                @openDetail="openDetail"
                                @recoverScore="recoverScore">
                        </list-item>
                    </div>
                </el-collapse-item>
            </el-collapse>

            <!--成功的检测项-->
            <p class="item-title main main-title" v-if="isFinish">
                以下<span class="success">{{progressData.itemNum - failList.length}}</span>项检测合格
            </p>
            <el-collapse v-model="activeWinIndexs" :class="{'finish': isFinish}">
                <el-collapse-item v-for="(classify, index) in getListData" :key="index" :name="index">
                    <template slot="title">
                        <p class="item-title">{{classify.title}}-共<span class="success">{{classify.children.length}}</span>项</p>
                    </template>
                    <div class="clearfix">
                        <list-item
                                v-for="(item, index) in classify.children"
                                :item="item"
                                :key="index"
                                :isFinish="isFinish"
                                @openDetail="openDetail">
                        </list-item>
                    </div>
                </el-collapse-item>
            </el-collapse>

            <!-- 详情对话框 -->
            <detail-dialog
                    :visible="dialogVisible"
                    @closeDialog="closeDialog"
                    :item-id="itemData._id">
            </detail-dialog>

            <!-- 手工加分对话框 -->
            <score-dialog
                    :visible="dialogScoreVisible"
                    :item-data="itemData"
                    @closeDialog="closeScoreDialog">
            </score-dialog>

        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'
    import listItem from './ListItem.vue'
    import detailDialog from './DetailDialog.vue'
    import scoreDialog from './ScoreDialog.vue'
	export default {
		components: {
			listItem,
            detailDialog,
            scoreDialog
        },
		data () {
			return {
                activeIndexs: ['0'],
                activeWinIndexs: [0],
                //详情弹框数据对象
				dialogVisible: false,
                itemData: {},
                //手工加分弹框数据对象
                dialogScoreVisible: false
            }
		},
        watch: {
            getListData (newVal) {
                if (!newVal) return;
                if (this.isFinish) {
                    this.activeWinIndexs.splice(0);
                }
            }
        },
        computed: {
            ...mapState('check', ['isFinish', 'progressData']),
            ...mapGetters('check', ['getListData', 'failList', 'getItemNum'])
        },
		methods: {
            ...mapActions('check', ['getItemData']),
		    //打开详细窗口
			openDetail (item) {
                this.itemData = item;
                this.dialogVisible = true;
            },
            closeDialog () {
                this.dialogVisible = false;
            },
            //手工加分
            recoverScore (item) {
                this.itemData = item;
                this.dialogScoreVisible = true;
            },
            closeScoreDialog () {
                this.dialogScoreVisible = false;
            }
        }
	}
</script>

<style lang="scss" scoped>
    .check-list {
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .item-title {
        display: inline-block;
        vertical-align: middle;
        margin: 0 0 0 2.7rem;
        font-size: .9rem;
        color: #1f1f20;
        &.main {
            line-height: 3.9rem;
            font-size: 1rem;
        }
    }
    .main-title {
        display: block;
        margin: 0;
        text-indent: 7.5rem;
        padding-left: 20px;
        border-bottom: 1px solid #dfe3ec;
    }
    .title {
        line-height: 40px;
        border-bottom: 1px solid #ccc;
        &.main {
            font-weight: 700;
            text-indent: 80px;
            cursor: default !important;
        }
        i {
            float: right;
            line-height: 40px;
        }
    }
    .list-item {
        padding-left: 80px;
        .title {
            cursor: pointer;
            &.main {
                margin-left: -80px;
            }
        }
    }
</style>
<style lang="scss">
    .check {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding-top: 205px;
        background-color: #fff;
        /*检查详情样式修改*/
        .el-collapse {
            border: 0;
            &.finish {

            }
        }
        .el-collapse-item {
            border-bottom: 1px solid rgb(223, 227, 236);
        }
        .el-collapse-item__header, .el-collapse-item__wrap {
            padding-left: 6rem;
            border-bottom: 0;
        }
        .el-collapse-item__header {
            position: relative;
            height: auto;
            line-height: 2.75rem;
        }
        .el-collapse-item__header__arrow {
            vertical-align: middle;
        }
        .el-collapse-item__arrow {
            position: absolute;
            top: 50%;
            float: none;
            color: #000;
            font-size: 18px;
            line-height: 48px;
            margin-top: -24px;
        }
        .el-collapse-item__content {
            padding: 10px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/detail/List.vue